import { render } from "./TrashProduct.vue?vue&type=template&id=bebb9d48"
import script from "./TrashProduct.vue?vue&type=script&lang=js"
export * from "./TrashProduct.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/maskansazangolchin-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__